import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  repetition: Yup.boolean(),
  meanValue: Yup.boolean(),
  standardDeviation: Yup.boolean(),
  targetValue: Yup.boolean(),
  atLeastOne: Yup.boolean().test(
    "at-least-one",
    "At least one value among repetition, mean value and standard deviation muss be selected ",
    // eslint-disable-next-line func-names
    function () {
      const { parent } = this;
      return parent.repetition || parent.meanValue || parent.standardDeviation || parent.targetValue;
    },
  ),
});

export default validationSchema;
